export interface Allowance {
  id: string;
  status: number;
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  effectiveFrom: string;
  effectiveTo?: string;
  amount: number;
  unit: number;
  pit?: boolean;
  insurance?: boolean;
  minWorkDayRate: number;
  byType: number;
  baseOnType?: string;
  receiveType: string;
  receiveBasePercent?: number;
}

export interface AllowanceListRequest {
  page?: number;
  limit?: number;
  name?: string | null;
  keyword?: string | null;
  code?: string | null;
  status?: number | null;
}

export interface AllowanceCreateRequest {
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  effectiveFrom: string;
  effectiveTo?: string;
  unit: number;
  amount: number;
  byType?: number;
  status: number;
  minWorkDayRate: number;
  receiveType: string;
  receiveBasePercent?: number;
  pit: boolean;
  insurance: boolean;
  baseOnType?: string;
}

export interface AllowanceUpdateRequest extends AllowanceCreateRequest {
  id: string;
}

export interface AllowanceListResponse extends RestAPIMetaResponse {
  items: Array<Allowance>;
}

export enum AllowanceUnit {
  Day = 1,
  Month = 3,
}

export enum AllowanceBaseOnType {
  GROSS = "GROSS",
  NET = "NET",
}

export enum AllowanceByType {
  AMOUNT = 1,
  PERCENT = 3,
}

export enum AllowanceReceiveType {
  PERCENT = "PERCENT",
  ACTUAL_WORKING_DAY = "ACTUAL_WORKING_DAY",
  TOTAL_WORKING_DAY = "TOTAL_WORKING_DAY",
}
